import { useTranslation } from 'react-i18next'

import { Skeleton } from '@/components/ui/skeleton'

import DashboardSection from './dashboard-section'

// Squelette d'une tuile de santé, même gabarit que ColorCard (libellé, valeur, légende) sur fond blanc :
// un bloc gris nu se confondrait avec le fond de page et donnerait l'impression d'un trou.
export function HealthTileSkeleton() {
  return (
    <div className="flex flex-col gap-2 rounded-lg border bg-white px-4 py-3">
      <Skeleton className="h-4 w-1/2" />
      <Skeleton className="h-8 w-1/3" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  )
}

// Squelette d'une carte compacte, même gabarit que KpiCard (tuile d'icône, titre, valeur, pastille)
// pour que la grille ne bouge pas quand les vraies cartes prennent la place.
export function KpiCardSkeleton() {
  return (
    <div className="flex h-full min-h-32 flex-col gap-2.5 rounded-xl bg-white px-4 py-3.5 shadow-sm">
      <div className="flex items-center gap-2.5">
        <Skeleton className="size-9 rounded-lg" />
        <Skeleton className="h-4 w-2/5" />
      </div>
      <Skeleton className="h-8 w-1/2" />
      <Skeleton className="mt-auto h-5 w-16 rounded-full" />
    </div>
  )
}

// Composant d'attente de la route : dessine la structure complète de la page (titre, 4 sections, mêmes
// grilles) pendant le chargement du code de la page, au lieu d'un spinner suivi d'un affichage en bloc.
// Les cartes prennent ensuite le relais avec leurs propres squelettes, le temps de leurs requêtes.
export default function DashboardSkeleton() {
  const { t } = useTranslation()

  return (
    <div className="flex grow flex-col gap-7" aria-busy="true">
      <div className="mt-5 flex items-center gap-3">
        <Skeleton className="size-10 rounded-lg" />
        <Skeleton className="h-8 w-40" />
      </div>

      <DashboardSection title={t('gtbDashboard.sections.health')}>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
          {Array.from({ length: 5 }, (_, index) => (
            <HealthTileSkeleton key={index} />
          ))}
        </div>
      </DashboardSection>

      <DashboardSection title={t('gtbDashboard.sections.families')}>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
          {Array.from({ length: 10 }, (_, index) => (
            <KpiCardSkeleton key={index} />
          ))}
        </div>
      </DashboardSection>

      <DashboardSection title={t('gtbDashboard.sections.activity')}>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-5">
          <div className="md:col-span-2">
            <KpiCardSkeleton />
          </div>
          <div className="md:col-span-3">
            <KpiCardSkeleton />
          </div>
        </div>
      </DashboardSection>
    </div>
  )
}
